import { app } from '../../app.module'
// TikTokアカウントデータのインタフェース
interface ITtAccountData {
  followers: number
  plays: number
  likes: number
  comments: number
  shares: number
  collects: number
  engagements: number
  engagementRate: number
  posts: number
}

/**
 * TikTokアカウントテーブルの平均
 * @class AccountTikTokTableAverageComponentCtrl
 */
class AccountTikTokTableAverageComponentCtrl {
  // アカウント一覧
  private sortAccounts: ITtAccountData[]
  // 1投稿あたりの平均フラグ
  private averagePerPost: boolean
  // 平均データ
  private averageData: ITtAccountData

  constructor() {
    this.averagePerPost = true
    this.averageData = {
      followers: 0,
      likes: 0,
      plays: 0,
      comments: 0,
      shares: 0,
      collects: 0,
      engagements: 0,
      engagementRate: 0,
      posts: 0,
    }
  }

  /**
   * アカウント一覧が変更されるまたは1投稿あたりの平均フラグが変更される時、平均を算出
   */
  public $onChanges(): void {
    this.calculateAverage()
  }

  /**
   * 平均を算出
   * @private
   * @returns {void}
   */
  private calculateAverage(): void {
    if (this.sortAccounts === undefined) {
      this.sortAccounts = []
    }
    this.averageData = {
      followers: 0,
      likes: 0,
      plays: 0,
      comments: 0,
      shares: 0,
      collects: 0,
      engagements: 0,
      engagementRate: 0,
      posts: 0,
    }
    if (this.sortAccounts.length === 0) {
      return
    }

    // 合計する
    this.sortAccounts.forEach((account) => {
      this.averageData.followers += account.followers
      this.averageData.posts += account.posts
      this.averageData.engagementRate += account.engagementRate
      // 1投稿あたりの平均の場合
      if (this.averagePerPost && account.posts > 0) {
        const posts = account.posts
        this.averageData.likes += account.likes / posts
        this.averageData.comments += account.comments / posts
        this.averageData.shares += account.shares / posts
        this.averageData.plays += account.plays / posts
        this.averageData.collects += account.collects / posts
        this.averageData.engagements += account.engagements / posts
      } else {
        // 1投稿あたりの平均ではないの場合
        this.averageData.likes += account.likes
        this.averageData.comments += account.comments
        this.averageData.shares += account.shares
        this.averageData.plays += account.plays
        this.averageData.collects += account.collects
        this.averageData.engagements += account.engagements
      }
    })

    // 平均する
    const sortAccountLength = this.sortAccounts.length

    this.averageData.followers /= sortAccountLength
    this.averageData.likes /= sortAccountLength
    this.averageData.plays /= sortAccountLength
    this.averageData.comments /= sortAccountLength
    this.averageData.shares /= sortAccountLength
    this.averageData.collects /= sortAccountLength
    this.averageData.engagements /= sortAccountLength
    this.averageData.engagementRate /= sortAccountLength
    this.averageData.posts /= sortAccountLength
  }
}

app.component('accountTiktokTableAverage', {
  bindings: {
    sortAccounts: '<',
    averagePerPost: '<',
  },
  template: require('./account-tiktok-table-average.pug')(),
  controller: AccountTikTokTableAverageComponentCtrl,
})
